type RegistrationFilters = {
	managerName?: string;
	department?: string;
	designation?: string;
	roleNameTemp?: string;
	email?: string;
};

export const bulkPermissionUrlPrefix: string = '/dashboard/forward/permissionsManagement-bulkPermission';

export type { RegistrationFilters };
